import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';

import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import * as primitives from './primitives';

export class TextArea extends PureComponent {
    static propTypes = {
        invalidMessage: PropTypes.string,
        name: PropTypes.string,
    };

    static defaultProps = {
        name: 'textarea',
    };

    render() {
        const {
            className,
            defaultValue,
            invalidMessage,
            onChange,
            ...otherProps
        } = this.props;

        return (
            <primitives.Wrapper
                className={className}
                data-test="textarea-wrapper"
            >
                <primitives.Textarea
                    data-test="textarea-input"
                    {...filterToValidAttributes(otherProps)}
                    data-invalid={invalidMessage}
                    defaultValue={defaultValue}
                    onChange={onChange}
                />

                {this.props.children}
                {this.renderInvalidErrorMessage(invalidMessage)}
            </primitives.Wrapper>
        );
    }

    renderInvalidErrorMessage(message) {
        if (message) {
            return (
                <ErrorMessage data-test="textarea-error">
                    {message}
                </ErrorMessage>
            );
        }
    }
}
